import SubserviceWrapper from "../../../components/Subservice/SubserviceWrapper";
import services from "../../../service.map";

import "./styles/apss.styles.css";

export const APSS = () => {
	return <SubserviceWrapper config={services.aplus} />;
};
